var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"black-bg"},[_c('VButton',{staticClass:"fade-up",attrs:{"title":_vm.$t('Alert.firstSearchBtn'),"ui-type":"primary","type":"button"},on:{"click":_vm.searchClicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }